var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"10.12.2017"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('Gallery',{attrs:{"directory":"2017/10"}}),_c('h2',[_vm._v("Puh, war das kalt damals!")]),_c('p',{staticClass:"center"},[_vm._v(" Da braucht man doch gleich einen ... ? ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }